export const NETLIFY_API_ROOT =
  "https://ajuskys-shop-api.netlify.app/.netlify/functions";
export const API_ROOT = "https://ajuskys-shop-api.netlify.app";
export const LOCAL_ROOT = "http://localhost:4444/.netlify/functions";
